import { FullPageContainer } from 'components/common/FullPageContainer';
import { LoadingOutlined } from '@ant-design/icons';

export default function FullPageSpinner(): JSX.Element {
  return (
    <FullPageContainer justifyContent='center' alignItems='center'>
      <LoadingOutlined />
    </FullPageContainer>
  );
}
